import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { UtensilsCrossed, Menu, X, LayoutDashboard, LogOut, Settings, Store } from "lucide-react";

const CORAL = "#FF5A36";
const INK = "#141210";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); setOpen(false); nav("/"); };
  if (loc.pathname.startsWith("/payment")) return null;

  const ownerLinks = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/impostazioni", label: "Impostazioni", icon: Settings },
  ];
  const linkCls = "px-4 py-2 text-sm font-semibold text-[#3f3a34] hover:text-[#FF5A36] rounded-full hover:bg-black/5 transition-colors flex items-center gap-2";

  return (
    <header className="sticky top-0 z-50 font-sans border-b border-black/5" style={{ background: "rgba(251,246,236,0.9)", backdropFilter: "blur(14px)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: CORAL }}>
            <UtensilsCrossed className="w-5 h-5 text-white transition-transform group-hover:rotate-12" />
          </span>
          <span className="font-display text-2xl font-extrabold tracking-tight" style={{ color: INK }}>Accontami</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {user && user.role === "owner" ? (
            <>
              {ownerLinks.map((l) => (
                <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`} className={linkCls}><l.icon className="w-4 h-4" /> {l.label}</Link>
              ))}
              <button data-testid="nav-logout-btn" onClick={doLogout} className={linkCls}><LogOut className="w-4 h-4" /> Esci</button>
            </>
          ) : (
            <>
              <Link to="/registra" data-testid="nav-register-restaurant" className={linkCls}><Store className="w-4 h-4" /> Registra il tuo ristorante</Link>
              <Link to="/login" data-testid="nav-login"
                className="ml-1 px-5 py-2.5 text-sm font-bold text-white rounded-full transition-transform hover:-translate-y-0.5"
                style={{ background: CORAL, boxShadow: "0 8px 20px rgba(255,90,54,0.35)" }}>
                Area ristoratori
              </Link>
            </>
          )}
        </nav>

        <button className="md:hidden" style={{ color: INK }} onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 px-5 py-4 space-y-1" style={{ background: "#FBF6EC" }}>
          {user && user.role === "owner" ? (
            <>
              {ownerLinks.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 font-semibold text-[#3f3a34] hover:text-[#FF5A36]">{l.label}</Link>
              ))}
              <button onClick={doLogout} className="block py-2 font-semibold text-[#3f3a34] w-full text-left">Esci</button>
            </>
          ) : (
            <>
              <Link to="/registra" onClick={() => setOpen(false)} className="block py-2 font-semibold text-[#3f3a34]">Registra il tuo ristorante</Link>
              <Link to="/login" onClick={() => setOpen(false)} className="block py-2 font-bold" style={{ color: CORAL }}>Area ristoratori</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
